import Header from "@/components/raffle/Header";
import Hero from "@/components/raffle/Hero";
import Prizes from "@/components/raffle/Prizes";
import FichaProgress from "@/components/raffle/FichaProgress";
import TicketAndCountdown from "@/components/raffle/TicketAndCountdown";
import PublicPickFicha from "@/components/raffle/PublicPickFicha";
import HowToParticipate from "@/components/raffle/HowToParticipate";
import ContactAndFooter from "@/components/raffle/ContactAndFooter";
import FloatingWhatsApp from "@/components/raffle/FloatingWhatsApp";
import PromoPopup from "@/components/raffle/PromoPopup";

export default function Home() {
  return (
    <main
      className="min-h-screen bg-[#051A0F] text-[#FDFBF7] relative grain-overlay"
      data-testid="home-page"
    >
      <PromoPopup />
      <Header />
      <Hero />
      <Prizes />
      <FichaProgress />
      <TicketAndCountdown />
      <PublicPickFicha />
      <HowToParticipate />
      <ContactAndFooter />
      <FloatingWhatsApp />
    </main>
  );
}
